import { operations, paths } from "./generated-types";
import createClient from "openapi-fetch";
import { sessionTokenMiddleware } from "@wiesinghilker/extension-lib-frontend";

const client = createClient<paths>({
  baseUrl: import.meta.env.VITE_APP_API_BASE_URI,
  credentials: "include",
});

client.use(sessionTokenMiddleware);

export const getProject = (params: operations["project.get"]["parameters"]) => {
  return client.GET("/projects/{projectId}", {
    params,
    signal: AbortSignal.timeout(2000),
  });
};

export const getPageSpeedSettings = (
  params: operations["appinstallation.get-pagespeed-settings"]["parameters"],
) => {
  return client.GET(
    "/projects/{projectId}/appinstallations/{appInstallationId}/pagespeed",
    { params, signal: AbortSignal.timeout(2000) },
  );
};

export const updatePageSpeedSettings = (
  body: operations["appinstallation.update-pagespeed-settings"]["requestBody"]["content"]["application/json"],
  params: operations["appinstallation.update-pagespeed-settings"]["parameters"],
) => {
  return client.PUT(
    "/projects/{projectId}/appinstallations/{appInstallationId}/pagespeed",
    { body, params, signal: AbortSignal.timeout(4000) },
  );
};

export const getPageSpeedMeasurement = (
  params: operations["appinstallation.get-pagespeed-measurement"]["parameters"],
) => {
  return client.GET(
    "/projects/{projectId}/appinstallations/{appInstallationId}/pagespeed/measurement",
    { params, signal: AbortSignal.timeout(2000) },
  );
};

export const createPageSpeedMeasurement = (
  params: operations["appinstallation.create-pagespeed-measurement"]["parameters"],
) => {
  return client.POST(
    "/projects/{projectId}/appinstallations/{appInstallationId}/pagespeed/measurement",
    { params, signal: AbortSignal.timeout(5000) },
  );
};
